import { IChannel } from '@alk/channel-hub';
import { injectable } from 'inversify';

import { IChannelConnector } from './channel-connector.interface';

@injectable()
export class ChannelConnectorMock implements IChannelConnector {
    getChannel(): Promise<IChannel> {
        return Promise.resolve({} as IChannel);
    }
}
